module.exports = __webpack_public_path__ + "assets/img/United World College of South East Asia.e5b92ee7.jpg";